import React, {FunctionComponent} from "react";
import {EmptyState} from "@atiautomacao/ati-ui-library";
import {CheckCircleOutline, ErrorOutline} from "@mui/icons-material";

// Estado vazio único da tela de Indisponibilidade (gráfico e grid), conforme o Design.
const UnavailabilityEmptyState: FunctionComponent<{height?: string}> = ({height}) => (
    <EmptyState
        title="Registros não encontrados"
        description="Não existem registros no momento"
        icon={<CheckCircleOutline/>}
        height={height}
    />
);

// Falha ao buscar os dados: não pode ser confundida com "não existem registros".
export const UnavailabilityErrorState: FunctionComponent<{height?: string}> = ({height}) => (
    <EmptyState
        title="Não foi possível carregar os dados"
        description="Tente novamente em instantes"
        icon={<ErrorOutline/>}
        height={height}
    />
);

export default UnavailabilityEmptyState;
